<template>
  <div class="ma-4 app">
    <v-sheet v-show="showSkeletonForm" class="pa-3">
      <v-row v-for="m in 2" :key="`form_4_col_${m}`">
        <v-col v-for="n in 3" :key="`line_form_2_col_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer v-for="p in 10" :key="`spacer_${p}`" />
        <v-col class="text-right">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
    </v-sheet>

    <v-form v-show="!showSkeletonForm">
      <v-row dense>
        <v-col>
          <CalendarWithMultipleAndRange
            label="Dias"
            v-model="dateSelected"
            :date-props="dateProps"
            :text-field-props="textProps"
          />
        </v-col>
        <v-col>
          <ClockRange
            min_max="true"
            label="Horas"
            v-model="timeSelected"
            :time-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
          />
        </v-col>
        <v-col>
          <v-autocomplete
            v-model="form.filas"
            :items="queues"
            outlined
            multiple
            dense
            label="Filas"
            :error-messages="filasErrors"
            @input="$v.form.filas.$touch()"
            @blur="$v.form.filas.$touch()"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.filas.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon :color="form.filas.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-text-field
            :value="numeroOrigem"
            @change="v => (numeroOrigem = v)"
            dense
            outlined
            label="Número Origem"
            hint="Ex.: 7000,7001"
            persistent-hint
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="maiorQue"
            @change="v => (maiorQue = v)"
            dense
            outlined
            label="Duração maior que"
            hint="hh:mm:ss"
            v-mask="['##:##:##', '##:##','##']"
            persistent-hint
            @input="$v.maiorQue.$touch()"
            :error-messages="maiorQueErrors"
          />
        </v-col>
         <v-col>
          <v-text-field
            :value="menorQue"
            @change="v => (menorQue = v)"
            dense
            outlined
            label="Duração menor que"
            hint="hh:mm:ss"
            v-mask="['##:##:##', '##:##','##']"
            persistent-hint
            @input="$v.menorQue.$touch()"
            :error-messages="menorQueErrors"
          />
        </v-col>
        <v-col>
          <v-autocomplete v-model="form.status" :items="status" outlined multiple dense label="Status">
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.status.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleStatus">
                <v-list-item-action>
                  <v-icon :color="form.status.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconStatus }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col>
          <v-autocomplete
            multiple
            dense
            outlined
            label="Centro de Custos"
            v-model="form.centrosDeCusto"
            :items="centrosDeCusto"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.centrosDeCusto.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleCentroDeCustos">
                <v-list-item-action>
                  <v-icon :color="form.centrosDeCusto.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconCentroDeCusto }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-right">
          <v-btn color="orangePcm" dark class="mr-2" @click="exportExcel">Exportar Excel</v-btn>
          <v-btn dark color="bluePcm" @click="gerar">Gerar</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-divider class="ma-2" />
    <v-sheet class="px-3 pt-3 pb-3" v-show="showSkeleton">
      <v-skeleton-loader class="mx-auto" type="button" />
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>
    <div v-show="showReport">
      <div v-show="!showSkeleton">
        <v-row v-if="chamadasRelatorio.length === 0">
          <v-col>
            <div class="text-h5">Não há informações com os filtros selecionados.</div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <div class="text-center d-flex pb-4">
              <v-btn @click="mostrar ? none() : all()" color="bluePcm" dark>
                {{ mostrar ? 'Esconder Todas' : 'Expandir Todas' }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <ExpandListMain :panel="panel" :chamadasRelatorio="chamadasPaginated" />
      </div>
      <v-row class="mt-2 mb-14" align="center">
        <span class="ml-8 grey--text">{{ initialItem }} - {{ finalItem }} de {{ totalItems }} Itens</span>
        <v-spacer />
        <ListPagination
          :page="currentPage"
          :numberOfPages="lastPageItem"
          @firstPage="firstPage"
          @formerPage="formerPage"
          @nextPage="nextPage"
          @lastPage="lastPage"
        />
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import relatorioFilaDetalhadoHttpService from '../_services/relatorioFilaDetalhadoHttpService';

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { initialAndFinalDateTextInputReportForm } from '@/mixins/initialAndFinalDateTextInputReportForm'

import relatoriosStore from '../../../../../store'

import { relatoriosFilasMixins } from '../../../_mixins/relatoriosFilasMixins'

import relatorioDetalhadoFilaStore from '../_store'
import ExpandListMain from '../_components/ExpandListMain'
import { validateData, validateComputed } from '../_validates'
import { relatorioDetalhadoFilaMethods } from '../_utils/relatorioDetalhadoFilaMethods'
import {mask} from 'vue-the-mask'


import CalendarWithMultipleAndRange from "@/componentes/CalendarWithMultipleAndRange";
import ClockRange from "@/componentes/ClockRange";
import moment from 'moment';

export default {
  name: 'relatoriosFila',
  directives: {mask},
  components: { ExpandListMain, ListPagination, CalendarWithMultipleAndRange, ClockRange },
  mixins: [initialAndFinalDateTextInputReportForm, relatoriosFilasMixins],
  data: () => ({
    form: {
      filas: [],
      status: [],
      numeroOrigem: [],
      centrosDeCusto: [],
      currentPage: 1,
      maiorQue: 0,
      menorQue: 0,
    },
    maiorQue: '',
    menorQue: '',
    numeroOrigem: '',
    centrosDeCusto: [],
    status: [
      { text: 'Atendidas', value: 'atendida' },
      { text: 'Abandonadas', value: 'abandonadas' },
      { text: 'Transbordo', value: 'timeout' },
    ],
    mostrar: false,
    panel: [],
    chamadasRelatorio: [],
    chamadasPaginated: [],
    showReport: false,
    totalItems: 0,
    currentPage: 1,
    itemsPerPage: 20,
    dateSelected:{},
    timeSelected:{},
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('relatoriosFilaStore', ['getCentrosDeCusto']),
    ...mapGetters('relatorioFilaDetalhadoStore', ['getDadosRelatorio']),
    ...validateComputed,


    initialItem() {
      return 1 + (this.currentPage - 1) * this.itemsPerPage
    },

    finalItem() {
      if (this.initialItem + (this.itemsPerPage - 1) > this.chamadasRelatorio.length) {
        return this.chamadasRelatorio.length
      }
      return this.initialItem + (this.itemsPerPage - 1)
    },

    lastPageItem() {
      return Math.ceil(this.chamadasRelatorio.length / this.itemsPerPage) || 0
    },

    // itemsPaginated() {
    //   let arrayCalls = []
    //   if (this.chamadasRelatorio.length === 0) {
    //     return []
    //   }
    //   for (let i = this.initialItem - 1; this.finalItem - 1; i++) {
    //     arrayCalls.push(this.chamadasRelatorio[i])
    //   }

    //   return arrayCalls
    // },

    todosStatusSelecionados() {
      return this.form.status.length === this.status.length
    },
    algunsStatusSelecionados() {
      return this.form.status.length > 0 && !this.todosStatusSelecionados
    },
    iconStatus() {
      if (this.todosStatusSelecionados) return 'mdi-close-box'
      if (this.algunsStatusSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    todosCentrosDeCustosSelecionados() {
      return this.form.centrosDeCusto.length === this.centrosDeCusto.length
    },
    algunsCentrosDeCustosSelecionados() {
      return this.form.centrosDeCusto.length > 0 && !this.todosCentrosDeCustosSelecionados
    },
    iconCentroDeCusto() {
      if (this.todosCentrosDeCustosSelecionados) return 'mdi-close-box'
      if (this.algunsCentrosDeCustosSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    dateTimeRange(){
      return {...this.dateSelected,...this.timeSelected}
    }
  },

  async created() {
    this.showSkeletonForm = true

    registerVuexModule(this.$store, 'relatoriosFilaStore', relatoriosStore)
    registerVuexModule(this.$store, 'relatorioFilaDetalhadoStore', relatorioDetalhadoFilaStore)

    await Promise.all([this.buscarCentroDeCustosNaApi(), this.buscarFilas()])

    this.queues = this.getQueues.map(fila => ({ text: fila.description, value: fila._id }))
    this.centrosDeCusto = this.getCentrosDeCusto.map(centroDeCusto => ({
      text: `${centroDeCusto.codigo} - ${centroDeCusto.description}`,
      value: centroDeCusto.codigo,
    }))

    this.toggleStatus()
    this.showSkeletonForm = false
    this.menorQue ="00:00:00"
    this.maiorQue ="00:00:00"
    this.timeSelected = {timeStart: '00:00', timeEnd: '23:59'}
    this.dateSelected = {dateIsRange: true, dates:[moment().format("YYYY-MM-DD")]}
  },

  methods: {
    ...mapActions('relatoriosFilaStore', ['buscarCentroDeCustosNaApi']),
    ...mapActions('relatorioFilaDetalhadoStore', ['gerarRelatorio']),
    ...relatorioDetalhadoFilaMethods,

    async exportExcel() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
        return;
      }else{
        this.form.dateTimeRange = this.dateTimeRange;
        const params = {
          dateTimeRange: this.dateTimeRange,
          filas: this.form.filas,
          status: this.form.status,
          numeroOrigem: this.form.numeroOrigem,
          centrosDeCusto: this.form.centrosDeCusto,
          maiorQue: this.form.maiorQue,
          menorQue: this.form.menorQue,
        }      
        window.open(relatorioFilaDetalhadoHttpService.exportExcel(params))
      }
    },

  },
  watch: {
    numeroOrigem(novo) {
      this.form.numeroOrigem = this.numeroOrigemFormer(novo)
      // if (this.form.numeroOrigem[0] === '' && this.form.numeroOrigem.length === 1) this.form.numeroOrigem.splice(0, 1)
    },
    maiorQue(novo) {
      this.form.maiorQue = this.maiorQueFormer(novo)
    },
    menorQue(novo) {
      this.form.menorQue = this.menorQueFormer(novo)
    },

    currentPage: {
      deep: true,
      immediate: true,
      handler() {
        this.chamadasPaginated.splice(0)

        let initialIndex = (this.currentPage - 1) * 20
        let finalIndex = initialIndex + 19

        if (finalIndex + 1 > this.chamadasRelatorio.length) {
          for (let i = initialIndex; i < this.chamadasRelatorio.length; i++) {
            this.chamadasPaginated.push(this.chamadasRelatorio[i])
          }
        } else {
          for (let i = initialIndex; i <= finalIndex; i++) {
            this.chamadasPaginated.push(this.chamadasRelatorio[i])
          }
        }
      },
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
